import { type TypedDocumentNode, gql } from '@apollo/client';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { HeadlineS } from '@sorare/core/src/atoms/typography';

import { Content } from './Content';
import type { CollectionUpsell_CardCollectionScoreIncrease } from './__generated__/index.graphql';

const Wrapper = styled(Vertical).attrs({ gap: 0 })`
  padding: var(--double-unit) 0;
  border-radius: var(--double-unit);
  border: 1px solid var(--c-nd-150);
`;

const Title = styled(Horizontal)`
  padding: 0 var(--double-unit);
`;

type Props = {
  affectedCardCollections: CollectionUpsell_CardCollectionScoreIncrease[];
};

export const CollectionUpsell = ({ affectedCardCollections = [] }: Props) => {
  if (!affectedCardCollections.length) {
    return null;
  }
  return (
    <Wrapper>
      <Title>
        <HeadlineS>
          <FormattedMessage
            id="cart.collectionUpsell.title"
            defaultMessage="Boost your collections"
          />
        </HeadlineS>
        <Tooltip title="something interesting">
          <FontAwesomeIcon icon={faInfoCircle} color="var(--c-nd-600)" />
        </Tooltip>
      </Title>
      <Content affectedCardCollections={affectedCardCollections} />
    </Wrapper>
  );
};

CollectionUpsell.fragments = {
  cardCollectionScoreIncrease: gql`
    fragment CollectionUpsell_CardCollectionScoreIncrease on CardCollectionScoreIncrease {
      id
      ...CollectionUpsellContent_CardCollectionScoreIncrease
    }
    ${Content.fragments.cardCollectionScoreIncrease}
  ` as TypedDocumentNode<CollectionUpsell_CardCollectionScoreIncrease>,
};
